import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
export default class LinkReel {
    constructor(x, y, index, orientation, linkCellCreation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 300;
        this.suspenseDuration = 600;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        /** Cells of the reel */
        this.linkCells = [];
        this.isFixedCell = false;
        this.t0 = 0;
        this.preStopMs = 2200; // tempo “attivo” prima del bounce (fisso!)
        this.spinMainButtonTween = null;
        this.isButtonSpinning = false;
        this.baseSpeed = 1.9; // velocità base
        this.speedJitter = 0.08; // piccola variazione
        this.delayPerReel = 120; // ms di ritardo per indice
        this.extraDelayJitter = 50; // jitter per non farli allineare
        this.index = index;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        this.numOfExtraLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_LINK_CELLS_PER_REEL;
        this.linkCellsPosition = linkCellCreation.cellPositions;
        this.lastLinkCellIndex = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL + this.numOfExtraLinkCellsPerReel - 1;
        this.container = layoutBuilder.findByPath(`LinkSpin/grid/reels/reel_${index}`);
        this.contornoLink = this.container.getByName(`contorno_link`);
        this.contornoLink.setTexture(ResourcesDispatcher.ATLAS.LINKCELL_FRAME.key, ResourcesDispatcher.ATLAS.LINKCELL_FRAME.frame);
        this.startDelayMs = index * this.delayPerReel + Phaser.Math.Between(0, this.extraDelayJitter);
        this.spinSpeed = this.baseSpeed + index * 0.12 + Phaser.Math.FloatBetween(-this.speedJitter, this.speedJitter);
        this.phaseOffsetPx = Math.round((index * (this.cellSize.height / ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS)) % this.cellSize.height);
    }
    /** PUBLIC GETTERS **/
    getIndex() {
        return this.index;
    }
    getCells() {
        return this.linkCells;
    }
    getContainer() {
        return this.container;
    }
    getIsFixedCell() {
        return this.isFixedCell;
    }
    /*******************/
    /** PUBLIC SETTERS **/
    setIndex(value) {
        this.index = value;
    }
    setIsFixedCell(value) {
        this.isFixedCell = value;
    }
    /*******************/
    resetFlagsAndCounters() {
        this.virtualReelPosition = Utils.getRandomInt(0, scene.linkSpinGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.canStop = false;
        this.stopped = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    resetCellsPositions() {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }
    reIndexCells() {
        let linkCells = [];
        for (let i = 1; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            linkCells[i - 1] = this.linkCells[i];
            this.linkCells[i].setIndex(i - 1);
        }
        this.linkCells[0].setIndex(this.lastLinkCellIndex);
        linkCells[this.lastLinkCellIndex] = this.linkCells[0];
        this.linkCells = [];
        this.linkCells = linkCells;
    }
    get stepMs() { return this.spinAnimationDuration / this.spinSpeed; }
    configureSpinTween() {
        this.resetFlagsAndCounters();
    }
    //Chiamato dal gioco per far partire il giro del rullo
    spin(mainButtonBackground) {
        if (this.isFixedCell) {
            scene.linkSpinGameArea.notifySpinCompleted(this.index);
            return;
        }
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground);
            }
        }
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    reset() {
        this.container.setVisible(true);
    }
    refreshCellPositions() {
        const numOfCells = this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel;
        for (let i = 0; i < numOfCells; i++) {
            const node = layoutBuilder.getNodeByPath(`LinkSpin/grid/reels/reel_${this.index}/cell_${i}`);
            if (node) {
                this.linkCellsPosition[i] = {
                    x: node.coordinates.relative_top_left_to_parent?.x || 0,
                    y: node.coordinates.relative_top_left_to_parent?.y || 0
                };
            }
        }
        this.linkCells.forEach(linkCell => {
            const pos = this.linkCellsPosition[linkCell.getIndex()];
            if (pos) {
                linkCell.getContainer().setPosition(pos.x, pos.y);
                linkCell.refreshInternalPositions();
            }
        });
    }
}
